export interface ICompanyPlanTaxCreditBrand {
  sellerRates: number[];
}

export enum ECompanyPlanTaxCreditMethod {
  default = "default",
  mastercard = "mastercard",
  visa = "visa",
  elo = "elo",
  discover = "discover",
  hipercard = "hipercard",
  american_express = "american_express",
}

export interface ICompanyPlanTaxCreditMethod {
  [ECompanyPlanTaxCreditMethod.elo]?: ICompanyPlanTaxCreditBrand;
  [ECompanyPlanTaxCreditMethod.visa]?: ICompanyPlanTaxCreditBrand;
  [ECompanyPlanTaxCreditMethod.default]?: ICompanyPlanTaxCreditBrand;
  [ECompanyPlanTaxCreditMethod.hipercard]?: ICompanyPlanTaxCreditBrand;
  [ECompanyPlanTaxCreditMethod.mastercard]?: ICompanyPlanTaxCreditBrand;
  [ECompanyPlanTaxCreditMethod.american_express]?: ICompanyPlanTaxCreditBrand;
}

export interface ICompanyPlanTaxCreditInstallment {
  pos?: ICompanyPlanTaxCreditMethod;
  tap?: ICompanyPlanTaxCreditMethod;
  online?: ICompanyPlanTaxCreditMethod;
}

export interface ICompanyPlanTaxMethodDetail {
  value: number;
  rateType: "PERCENTAGE" | "FIXED" | string;
  valueLimit?: number;
}

export interface ICompanyPlanTaxByMcc {
  pix?: Record<string, ICompanyPlanTaxMethodDetail>;
  debit?: Record<string, ICompanyPlanTaxMethodDetail>;
  bankSlip?: Record<string, ICompanyPlanTaxMethodDetail>;
  creditCard?: Record<string, ICompanyPlanTaxCreditInstallment>;
}

export interface ICompanyPlanTax {
  taxConfigsByMcc: Record<string, ICompanyPlanTaxByMcc>;
}

export interface ICompanyPlan {
  id: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  idCompanies: number[];
  tax: ICompanyPlanTax;
}
